let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("i2OFv"), load("l7m0F"), load("hNn7N"), load("2AOLi"), load("c6MKV"), load("5TCys")]).then(() => parcelRequire('1wIcl'));